function text(value) {
  return String(value == null ? '' : value).trim()
}

function yes(value) {
  const normalized = text(value).toLowerCase()
  return value === true || value === 1 || normalized === '1' || normalized === 'true' || normalized === 'yes'
}

function positiveNumber(value) {
  const number = Number(value)
  return Number.isFinite(number) && number > 0
}

function hasCardValue(item) {
  if (!item || typeof item !== 'object') return false
  return [
    item.bankCard,
    item.bank_card,
    item.cardNo,
    item.card_no,
    item.cardNumber,
    item.accountNo,
    item.account_no
  ].some(value => text(value))
}

export function hasVerifiedRealName(profile) {
  const data = profile && typeof profile === 'object' ? profile : {}
  return [
    data.realName,
    data.real_name,
    data.realname,
    data.name,
    data.accountName,
    data.account_name
  ].some(value => text(value))
}

export function hasWithdrawalPassword(profile) {
  const data = profile && typeof profile === 'object' ? profile : {}
  return yes(data.privacyPasswdSetted) || yes(data.privacyPasswordSet) || yes(data.withdrawPasswordSet)
}

export function hasBankCard(profile) {
  const data = profile && typeof profile === 'object' ? profile : {}
  const lists = [data.bankCardList, data.bankCards, data.cardList, data.bankList]

  if (lists.some(list => Array.isArray(list) && list.some(item => hasCardValue(item) || text(item)))) {
    return true
  }

  if (yes(data.hasBankCard) || yes(data.bankCardSetted) || yes(data.bankCardSet)) return true
  if (positiveNumber(data.bankCardCount) || positiveNumber(data.bankCount) || positiveNumber(data.cardCount)) return true

  return [
    data.bankCard,
    data.bank_card,
    data.cardNo,
    data.card_no,
    data.cardNumber,
    data.accountNo,
    data.account_no
  ].some(value => text(value))
}

export function getMineActionRoute(action, options) {
  const config = options && typeof options === 'object' ? options : {}
  const profile = config.profile && typeof config.profile === 'object' ? config.profile : {}
  const source = text(config.source) || 'mine'

  if (!config.loggedIn) return { requiresLogin: true }

  if (action === 'deposit') return { path: '/rechargeCont' }

  if (action === 'withdraw') {
    const withdrawSource = 'withdraw'
    if (!hasVerifiedRealName(profile)) return { path: '/authName', query: { from: source } }
    if (!hasWithdrawalPassword(profile)) return { path: '/setPassWord', query: { from: withdrawSource } }
    if (!hasBankCard(profile)) return { path: '/bankAdd', query: { from: withdrawSource, tab: 'bank' } }
    return { path: '/bankAdd', query: { from: withdrawSource, tab: 'withdraw' } }
  }

  if (action === 'bank') {
    if (!hasVerifiedRealName(profile)) return { path: '/authName', query: { from: source } }
    if (!hasBankCard(profile)) return { path: '/bankAdd', query: { from: source } }
    return { path: '/bank', query: { from: source } }
  }

  return { path: '/home' }
}
